export default {"src":"/_next/static/media/thumbs-up-in-bandage.c78e5824.svg","height":273,"width":329};